import React from 'react'
import slugify from 'slugify'
import {
  Box,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@mui/material'
import { Helmet } from 'react-helmet'

import { PortableText } from '@components/PortableText'
import { Icon } from '@components/Icon'

type CombinationFaqsSanityPropsType = {
  faqs: {
    question: string
    _rawFaqAnswer: {
      children: {
        text: string
      }[]
    }[]
  }[]
}

export const CombinationFaqsSanity = ({
  faqs
}: CombinationFaqsSanityPropsType) => {
  const structuredData: Array<{
    '@type': string
    name: string
    acceptedAnswer: object
  }> = []
  faqs?.forEach(item => {
    structuredData.push({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item._rawFaqAnswer[0].children.map(({ text }) => text).join(' ')
      }
    })
  })
  return (
    <>
      <Helmet>
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: structuredData
          })}
        </script>
      </Helmet>
      <Typography variant='h6' mt={6} mb={2}>
        Frequently Asked Questions
      </Typography>
      <Box
        sx={{
          borderWidth: 1,
          borderColor: 'border.main',
          borderRadius: 2,
          overflow: 'hidden'
        }}>
        {faqs?.map(({ question, _rawFaqAnswer }) => {
          const slug = slugify(question, { lower: true, strict: true })

          return (
            <Accordion
              key={question}
              sx={{
                background: 'none',
                boxShadow: 'none',
                '&:before': {
                  opacity: 0
                },
                borderColor: 'border.main',
                '&:not(:first-child)': {
                  borderTopWidth: 1
                },
                '&.Mui-expanded': {
                  m: 0
                }
              }}>
              <AccordionSummary
                expandIcon={<Icon icon='chevron-down' fontSize='12px' />}
                aria-controls={`${slug}-content`}
                id={`${slug}-header`}>
                <Typography fontWeight={500}>{question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ color: 'text.secondary' }}>
                <PortableText blocks={_rawFaqAnswer} />
              </AccordionDetails>
            </Accordion>
          )
        })}
      </Box>
    </>
  )
}
